import moment from "moment-timezone";

export const formatDate = (value, format, timeZone) => {
  const date = moment.utc(value);
  return timeZone === "Local"
    ? date.local().format(format)
    : date.tz(timeZone).format(format);
};
